const FNV_PRIME = 0x01000193;
const FNV_OFFSET_BASIS = 0x811c9dc5;

/** A second basis gives an independent 32-bit lane, so two passes make a 64-bit digest. */
const FNV_OFFSET_BASIS_ALT = 0x811c9dc5 ^ 0x5bf03635;

/**
 * Returns a stable 16-character hex digest of `value`, computed with two FNV-1a lanes.
 *
 * Not cryptographic:
 * - Same input always gives the same digest, in any browser and any build.
 * - An attacker who can enumerate the possible inputs can recover them by hashing candidates.
 */
export function hashString(value: string): string {
  return `${fnv1a(value, FNV_OFFSET_BASIS)}${fnv1a(value, FNV_OFFSET_BASIS_ALT)}`;
}

function fnv1a(value: string, basis: number): string {
  let hash = basis;

  for (let i = 0; i < value.length; i++) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, FNV_PRIME);
  }

  return (hash >>> 0).toString(16).padStart(8, '0');
}
